<div [class]="'sidepanel ' + position + (isVisible ? ' visible' : '')" *ngIf="hasContent || isVisible">
  <!-- Toggle button - always visible when there's content -->
  <div class="toggle-button" *ngIf="hasContent">
    <button class="toggle-btn" (click)="toggle()">
      <i [class]="getToggleIcon()"></i>
      <div class="vertical-title">
        <span *ngFor="let char of panelTitle.split('')">{{ char }}</span>
      </div>
    </button>
  </div>

  <!-- Expanded state: show complete panel -->
  <div *ngIf="isVisible" class="panel-container">
    <div class="panel-header">
      <h3 class="panel-title">{{ panelTitle }}</h3>
    </div>

    <!-- Dynamic component using NgComponentOutlet -->
    <div class="panel-body">
      <ng-container
        *ngComponentOutlet="dynamicComponent; inputs: componentInputs">
      </ng-container>
    </div>
  </div>
</div>
